// Medications section form field enum
export enum MedicationsFormField {
  // Medication list
  MEDICATIONS_MEDICATION_LIST = 'medications',

  // Summary
  MEDICATIONS_MEDICATION_SUMMARY = 'medications/medication-summary'
}
